/* eslint-disable quote-props */
import React from 'react';

export const baseUrl = (process.env.NODE_ENV === 'production') ? 'http://13.127.181.88:3000' : 'http://14.14.14.14:3000';
export const env = (process.env.NODE_ENV === 'production') ? 'prod' : 'dev';
export const dataEntryPaths = {
  'factsheet/basic_org_details': 'factsheet/od',
  'factsheet/management_details': 'factsheet/md',
  'factsheet/present_banking_arrangement': 'factsheet/pba',
  'factsheet/proposed_loans': 'factsheet/pl',
  'factsheet/securities': 'factsheet/securities',
  'factsheet/securities/documents': 'factsheet/securities/:id/documents',
  'factsheet/company_bg': 'factsheet/addDetails',
  'factsheet/promoters_bg': 'factsheet/addDetails',
  'factsheet/project_bg': 'factsheet/addDetails',
  'factsheet/ecosystem_brief': 'factsheet/addDetails',
  'factsheet/other_comments': 'factsheet/addDetails',
  'factsheet/associate_concerns': 'factsheet/ac',
  'factsheet/present_banking_arrangement/repayment_schedule': 'factsheet/pba/:id/rs',
  'factsheet/present_banking_arrangement/securities': 'factsheet/pba/:id/securities',
  'factsheet/present_banking_arrangement/loan_statements': 'factsheet/pba/:id/loanStatements',
  'factsheet/associate_concerns/management_details': 'factsheet/ac/:id/management',
  'factsheet/associate_concerns/company_background': 'factsheet/ac/:id/company',
  'factsheet/associate_concerns/debt_position': 'factsheet/ac/:id/debt',
  'factsheet/associate_concerns/brief_financials': 'factsheet/ac/:id/financials',
};
export const months = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};
export const draftToolbarOptions = {
  options: ['inline', 'blockType', 'fontSize', 'list', 'history'],
  inline: {
    options: ['bold', 'italic', 'underline'],
  },
  blockType: {
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
  },
};

export const tagDisplayName = (tag) => tag.replace(/[-]/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

export const currencyFormat = (number) => (number ? number.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }) : 0);

const yrsArray = [];
const currentYear = new Date().getFullYear();
for (let i = 0; i < 15; i++) {
  yrsArray.push(currentYear - i);
}
export const yearsSelectArray = yrsArray;

export const bizminderColors = ['#0095D4', '#56C5D0', '#E02E26', '#F58343', '#53A276'];

export const themes = ['lac', 'pa', 'ta', 'dac', 'crm', null];

export const removeEmpty = (obj) => {
  const newObj = { ...obj };
  Object.entries(newObj).forEach(([key, val]) => {
    if (!val) delete newObj[key];
  });
  return newObj;
};

export const newCurrentProposal = () => ({
  id: (+new Date()).toString(36),
  remark: '',
  cc: 0,
  tl: 0,
  lc: 0,
  bg: 0,
  other: 0,
});

export const financialSummaryEntries = [
  {
    noValue: false,
    id: 'fs1',
    name: 'Sales',
  },
  {
    noValue: false,
    id: 'fs2',
    name: 'PAT',
  },
  {
    noValue: false,
    id: 'fs3',
    name: 'EBIDTA',
  },
  {
    noValue: false,
    id: 'fs4',
    name: 'Capital',
  },
  {
    noValue: false,
    id: 'fs5',
    name: 'Net worth',
  },
  {
    noValue: false,
    id: 'fs6',
    name: 'Quasi Equity',
  },
  {
    noValue: false,
    id: 'fs7',
    name: 'Adjusted Net worth',
  },
  {
    noValue: false,
    id: 'fs8',
    name: 'Net Fixed Assets',
  },
  {
    noValue: false,
    id: 'fs9',
    name: 'Total Long-Term Debt',
  },
  {
    noValue: false,
    id: 'fs10',
    name: 'Total Short-Term Debt',
  },
  {
    noValue: true,
    id: 'fsSh1',
    name: 'Profitability Ratios',
  },
  {
    noValue: false,
    id: 'fs11',
    name: 'EBIDTA Margin',
  },
  {
    noValue: false,
    id: 'fs12',
    name: 'PAT Margin',
  },
  {
    noValue: true,
    id: 'fsSh2',
    name: 'Leverage/ Coverage Ratios',
  },
  {
    noValue: false,
    id: 'fs13',
    name: 'Debt Equity Ratio',
  },
  {
    noValue: false,
    id: 'fs14',
    name: 'Interest Coverage ratio',
  },
  {
    noValue: false,
    id: 'fs15',
    name: 'TOL/ATNW',
  },
  {
    noValue: false,
    id: 'fs16',
    name: 'Debt Service Coverage Ratio',
  },
  {
    noValue: true,
    id: 'fsSh3',
    name: 'Turnover Ratios',
  },
  {
    noValue: false,
    id: 'fs17',
    name: 'Average Inventory Period - FG',
  },
  {
    noValue: false,
    id: 'fs18',
    name: 'Average Collection Period',
  },
  {
    noValue: false,
    id: 'fs19',
    name: 'Average Creditors Period',
  },
  {
    noValue: true,
    id: 'fsSh4',
    name: 'Liquidity Ratios',
  },
  {
    noValue: false,
    id: 'fs20',
    name: 'Current Ratio',
  },
];

export const amountUnitDetails = {
  crore: {
    name: 'Crores',
    symbol: 'cr',
  },
  lakh: {
    name: 'Lakhs',
    symbol: 'lac',
  },
  million: {
    name: 'Millions',
    symbol: 'million',
  },
};

export const leadFinancialSummaryNames = {
  sales: 'Sales',
  otherIncome: 'Other Income',
  netProfit: 'Net Profit',
  interestExpLoans: 'Interest Exp - Loans',
  interestExpOthers: 'Interest Exp - Others',
  depreciation: 'Depreciation',
  tax: 'Tax',
  ebidta: 'EBIDTA',
  capital: 'Capital',
  unsecuredLoans: 'Unsecured Loans',
  longTermLoans: 'Long Term Loans',
  shortTermLoans: 'Short Term Loans',
  tolByTnw: 'TOL/TNW',
  currentRatio: 'Current Ratio',
};

export const natureOfChargeOptions = [
  { label: 'First & Exclusive', value: 'First & Exclusive' },
  { label: 'Pari passu', value: 'Pari passu' },
  { label: 'First & Pari passu', value: 'First & Pari passu' },
  { label: 'Second', value: 'Second' },
  { label: 'Second & Pari passu', value: 'Second & Pari passu' },
];

export const textareaToHtml = (textarea) => (
  <span dangerouslySetInnerHTML={{ __html: textarea.replace(/\r?\n|\r/g, '<br />') }} />
);

export const removeTypenameFromArrays = (arr) => (arr.map((entry) => {
  const { __typename, ...newEntry } = entry;
  return newEntry;
}));

export default null;



// WEBPACK FOOTER //
// ./src/utils/globals.js